import { clearSearchHistory } from "src/main/resources/js/lib/util/clearSensitiveSessionData";
import { TLCEvents } from "../../../../js/lib/events/events";
import { TLCLogger } from "../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { TLCCookie } from "../../Managers/CookieManager";
import { ApplicationData } from "../ApplicationData";
import { LoginClientManager } from "../ClientManagers/LoginClientManager";

/**
 * @deprecated only used by LS2Kids, should be moved to ls2kids folder...
 */
export const TimeoutPageControl = (function ( $, global ) {
	var pageTimeout = 600000, // 10 minutes
	//    var pageTimeout = 5000,
		isTimedOut = false,
		timer;


	function _init() {
		_changeTimeout( ApplicationData.globalConfiguration.globalSettings.timeTillTimeout * 60 * 1000 );

		$( document.body ).on("click", getKillTimerHandler() );
		$( document.body ).on( "mousemove", getKillTimerHandler() );
		$( document.body ).on( "keypress", getKillTimerHandler() );
		$( document.body ).on( "touchend", getKillTimerHandler() );
	}

	function _changeTimeout( newTime ) {
		pageTimeout = newTime;
		_startTimer();
	}

	function _startTimer() {
		clearTimeout( timer );
		timer = setTimeout( function () {
			_onTimeout();
		}, pageTimeout );

		if( isTimedOut ) {
			TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onTimeoutCancel );
			isTimedOut = false;
		}
	}


function _onTimeout() {
	clearSearchHistory();
	
	isTimedOut = true;
	TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onTimeout );
	TLCLogger.log( "application timed out" );

	//the page redirect will automatically log you out so we don't have to call logout first

	if( ApplicationData.locationConfiguration.isADFSEnabled() ) {
		if (ApplicationData.locationConfiguration.useADFSRedirect()) {
			location.href = ApplicationData.locationConfiguration.getADFSTimeoutUrl();
		} else {
			TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onHome );
		}
	} else if( _hasAlternateTimeout() ) {
		global.location = ApplicationData.locationConfiguration.getAlternateTimeoutPageUrl();
	} else {
		// SPRING_SECURITY_REMEMBER_ME_COOKIE is set as HttpOnly so this always evaluates to undefined and user is logged out
		if( TLCCookie.get( LS2PAC_CONSTANTS.rememberMeCookieName ) !== undefined ) {
			TLCEvents.trigger( LS2PAC_CONSTANTS.Events.onHome );
		} else {
			//logout should bring them back to the "Home Page"
			LoginClientManager.onLogout();
		}
	}
}

	function _hasAlternateTimeout() {
		return ApplicationData.locationConfiguration.getUseAlternateTimeoutPage() && ApplicationData.locationConfiguration.getAlternateTimeoutPageUrl() != "";
	}


	/**                       **
	 **    Helper functions   **
	 **                       **/

	var getKillTimerHandler = function () {
		return function ( event ) {
			//TLCLogger.log("killing timer", event.type);
			_startTimer();
		}
	};


	/**                       **
	 **    Public functions   **
	 **                       **/
	return {
		init:          _init,
		changeTimeout: _changeTimeout, 
		onTimeout: _onTimeout
	};

})( jQuery, window );
